<template>
    <v-content>
        <v-toolbar class="content-toolbar">
            <v-btn flat class="back-button" v-on:click="$router.go(-1)">
                <font-awesome-icon :icon="['far', 'chevron-left']" size="2x"/>
            </v-btn>
            <font-awesome-icon :icon="['fal', 'pencil-alt']" size="2x"/>
            <v-toolbar-title>{{title}}</v-toolbar-title>

        </v-toolbar>

        <div class="content-container">
            <div class="form-container">
                <v-container fill-height class="fields-container">
                    <v-layout>
                        <v-flex>
                            <div v-if="contentType">
                                <v-form>
                                    <div class="field-container-1">
                                        <sfr-file-selection-field ref="file-selector"
                                                                  :allowsMultiple="true"
                                                                  :existing-asset="existingAsset"
                                                                  :selected-files="selectedFiles"
                                                                  v-on:sfr:file-selected="onFileInputChange"
                                                                  v-on:sfr:touched="touchState">
                                        </sfr-file-selection-field>
                                    </div>
                                </v-form>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
            <div class="crud-sidebar-container">
                <v-navigation-drawer permanent class="crud-sidebar">
                    <div>
                        <template>
                            <v-subheader>Actions</v-subheader>
                            <v-divider></v-divider>
                            <div class="right-side-bar">
                                <div>
                                    <v-btn block color="info"
                                           v-on:click="addAllMedia"
                                           :loading="totalLoadingState.state === LOADING_STARTED"
                                           :disabled="totalLoadingState.state === LOADING_STARTED || !isValid">
                                        <span class="capitalize-text">Add Assets</span>
                                        <v-progress-circular v-if="totalLoadingState.progress !== 100" slot="loader"
                                                             :value="totalLoadingState.progress" :width="3"
                                                             :rotate="-90"></v-progress-circular>
                                        <v-progress-circular v-else slot="loader" indeterminate
                                                             :width="3"></v-progress-circular>
                                    </v-btn>
                                </div>
                            </div>
                        </template>
                    </div>
                </v-navigation-drawer>
            </div>
        </div>
        <v-snackbar
                :timeout="snackBar.timeout"
                :bottom="true"
                v-model="snackBar.isShowing"
                :color="snackBar.color">
            {{ snackBar.text }}
            <v-btn dark flat @click.native="snackBar.isShowing = false">Ok</v-btn>
        </v-snackbar>
    </v-content>

</template>

<script>
    import BaseLoadingComponent from './BaseLoading'
    import http from '../services/axios'
    import lodash from '../services/lodash'
    import moment from '../services/moment'

    import {
        LOAD_SPACE_CONTENT,
        LOADING_COMPLETED_FAILURE,
        LOADING_COMPLETED_SUCCESS,
        LOADING_PRISTINE,
        LOADING_STARTED,
        DRAFT_TEXT,
        PUBLISHED_TEXT,
        ARCHIVED_TEXT,
        GET_NESTED_CREATION_STACK_TOP,
        SET_REFERENCE_NESTED_CREATION_OBJECT_STACK_TOP,
    } from "../services/constants"
    import helpers from '../services/helpers'

    export default {
        name: 'add-multiple-media',
        extends: BaseLoadingComponent,
        data: function () {
            return {
                assetsContentType: 'asset',
                existingAsset: null,
                status: PUBLISHED_TEXT,
                statusStates: {
                    draft: DRAFT_TEXT,
                    publish: PUBLISHED_TEXT,
                    archive: ARCHIVED_TEXT,
                },
                formModel: {},
                hiddenFormModel: {},
                selectedFiles: [],
                isFormValid: false,
                isFormDirty: false,
                isFormPopulated: false,
                totalLoadingState: {
                    state: LOADING_PRISTINE,
                    progress: 0,
                },
                mediaRefTemplate: {
                    state: LOADING_PRISTINE,
                    fileRef: null,
                    progress: 0,
                },
                snackBar: {
                    isShowing: false,
                    text: '',
                    color: 'info',
                    timeout: 6000
                },
            }
        },
        computed: {
            contentType: function () {
                return this.$store.state.media.spaceAssetContentType
            },
            fields: function () {
                if (this.$store.state.media.spaceAssetContentType) {
                    return this.$store.state.media.spaceAssetContentType.fields.filter(helpers.excludeMediaFields)
                } else {
                    return []
                }
            },
            title: function () {
                let title = ''
                if (this.contentType) {
                    title += this.contentType.name
                    title += ' > Multiple'
                }
                return title
            },
            isValid() {
                return this.selectedFiles.length > 0
            }
        },
        watch: {
            contentType() {
                this.buildFormModel()
            },
        },
        methods: {
            buildFormModel: function () {
                if (this.contentType) {
                    this.fields.forEach(field => {
                        if (!this.formModel[field.identifier]) {
                            this.$set(this.formModel, field.identifier, {})
                            switch (field.type) {
                                case 'text_short':
                                    this.$set(this.formModel[field.identifier], 'value', '')
                                    this.$set(this.formModel[field.identifier], 'valid', false)
                                    break
                                case 'text_long':
                                    this.$set(this.formModel[field.identifier], 'value', '')
                                    this.$set(this.formModel[field.identifier], 'valid', false)
                                    break
                                case 'boolean':
                                    this.$set(this.formModel[field.identifier], 'value', false)
                                    this.$set(this.formModel[field.identifier], 'valid', true)
                                    break
                                default:
                                    this.$set(this.formModel[field.identifier], 'value', null)
                                    this.$set(this.formModel[field.identifier], 'valid', false)
                                    break
                            }
                        }
                    })
                }
            },
            getPrimaryDisplayIdentifier: helpers.getPrimaryDisplayIdentifier,
            getPrimaryDisplayName: helpers.getPrimaryDisplayName,
            touchState: function () {
                this.isFormDirty = true
            },
            onFileInputChange: function (fileObjs) {
                this.selectedFiles = fileObjs.map(fileObj => {
                    const ref = lodash.cloneDeep(this.mediaRefTemplate)
                    ref.fileRef = fileObj
                    return ref
                })
            },
            addAllMedia() {
                const tasks = this.selectedFiles.map(mediaRef => {
                    return this.addMedia(mediaRef)
                });
                return tasks.reduce((promiseChain, currentTask) => {
                    return promiseChain.then(chainResults =>
                        currentTask.then(currentResult =>
                            [...chainResults, currentResult]
                        )
                    );
                }, Promise.resolve([])).then(results => {
                    this.$store.dispatch(LOAD_SPACE_CONTENT, {
                        identifier: this.assetsContentType
                    }).then(results2 => {
                        this.totalLoadingState.state = LOADING_COMPLETED_SUCCESS
                        this.isFormDirty = false
                        this.isFormPopulated = true
                        this.showSnackBar('All Media added.', LOADING_COMPLETED_SUCCESS)
                        this.$router.push({
                            name: 'spaceDashboardMedia',
                        })

                    })
                }).catch(err => {
                    this.totalLoadingState.state = LOADING_COMPLETED_FAILURE
                    this.showSnackBar('Adding entry failed.', LOADING_COMPLETED_FAILURE)
                    console.log(err)
                })
            },

            addMedia(mediaRef) {
                mediaRef.state = LOADING_STARTED
                const exitObj = {}
                exitObj['fields'] = []
                for (const key of Object.keys(this.formModel)) {
                    const field = {}
                    field['identifier'] = key
                    if (key === 'name') {
                        field['value'] = mediaRef.fileRef.name
                    } else {
                        field['value'] = this.formModel[key].value
                    }
                    exitObj['fields'].push(field)
                }
                exitObj['status'] = this.status
                const formData = new FormData()
                formData.append('entryCreation', JSON.stringify(exitObj))
                formData.append('file', mediaRef.fileRef)
                return http.post(`api/management/spaces/${this.$store.state.spaceMetadata.id}/assets`, formData, {
                    onUploadProgress: function (progressEvent) {
                        if (progressEvent.lengthComputable) {
                            mediaRef.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        }
                    }
                })
            },
            showSnackBar: function (text, status) {
                this.snackBar.text = text
                switch (status) {
                    case LOADING_COMPLETED_SUCCESS:
                        this.snackBar.color = 'success'
                        break
                    case LOADING_COMPLETED_FAILURE:
                        this.snackBar.color = 'error'
                        break
                    default:
                        this.snackBar.color = 'info'
                        break
                }
                this.snackBar.isShowing = true
            },
            cssComputeStatusColor: helpers.cssComputeStatusColor,
        },
        created() {
            if (this.contentType) {
                this.buildFormModel()
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../meta";

    $offset-height: 68px;
    .content-toolbar {
        position: fixed;
        margin-bottom: 4px;
        z-index: 4;
        .back-button {
            height: 100%;
            margin: 0 1em 0 0;
        }
    }

    .content-container {
        display: flex;
        margin: $offset-height 0 0 0;
        height: calc(100% - 68px);
        justify-content: center;

        .form-container {
            margin: 0 300px 0 0;
        }

        .fields-container {
            max-width: 1000px;
            min-width: 600px;
        }

        .crud-sidebar-container {
            height: 100%;
            position: fixed;
            right: 0;
        }

        .crud-sidebar {
            z-index: 3;
        }
    }

    .right-side-bar {
        padding: 1em;
    }

    .icon-status {
        margin: 0 .75em 0 0;
    }

    .field-container-1 {
        margin: 2em 0;
        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .text-long-header {
        font-size: 14px;
        margin: 0 0 1em 0;
    }

    .regular-type-header {
        font-size: 14px;
        .input-group {
            padding: 0px;
        }
    }

    .hint-text {
        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;

        &.custom-validation-error-text {
            color: $error
        }
    }

    .switch-content {
        display: flex;
        align-items: center;
    }

    .icon-spacer {
        width: 0.5em;
    }

    .linked-entry {
        font-weight: bold;
        $border-width: 1px;
        border-left: $border-width solid $accent;
        margin: 13px 0 0 0;
        padding: 0 0 0 4px;
    }

    .datetime-pickers-container {
        display: flex;

        .date-picker-container {
            margin: 0 1em 0 0;
        }
    }

    .file-field-data-container {
        margin: 1em 0;
        .data-table-thumbnail {
            $size: 30px;
            max-height: $size;
            max-width: $size;
            vertical-align: middle;
            margin: 0 1em 0 0;
        }

        .category-icon {
            margin: 0 .5em 0 0;
        }
        a.file-field-link {
            color: blue;
        }
    }

    .dropzone-comp {
        /*margin: 2em 0 0 0;*/
    }


</style>
